module.exports = __webpack_public_path__ + "static/media/2.135c8f9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/vitebsk/2.jpg
// module id = 249
// module chunks = 0